import { notification } from "antd";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useMutation, useQueryClient } from "react-query";
import FirebaseSdk from "../../FirebaseSdk";
import { useUserAuth } from "../../ui-hooks/useUserAuth";
import { listUsersByIdsQueryKey } from "../queries/useListUsersByIds";
import { settledLogger } from "../settledLogger";
import { storagePaths } from "../storagePaths";
import { useUpdateUserMutation } from "./useUpdateUserMutation";

export const useUploadAvatarUrlMutation = () => {
  const queryClient = useQueryClient();
  const { user } = useUserAuth();
  const { mutate: updateUser } = useUpdateUserMutation(user?.uid || "");
  const storage = FirebaseSdk.getStorage();
  const uploadAvatarUrl = async (file: Blob | Uint8Array | ArrayBuffer) => {
    if (user) {
      const avatarUrlRef = ref(storage, storagePaths.avatarUrls(user.uid));
      await uploadBytes(avatarUrlRef, file);
      const avatarUrl = await getDownloadURL(avatarUrlRef);
      return updateUser({ avatarUrl });
    } else {
      notification.error({ message: "Not signed in" });
    }
  };
  return useMutation(uploadAvatarUrl, {
    onSettled: settledLogger("useUploadAvatarUrlMutation"),
    onSuccess: () => {
      queryClient.invalidateQueries(listUsersByIdsQueryKey([user?.uid || ""]), {
        refetchInactive: true,
      });
    },
  });
};
